import { h } from 'preact'
import { MandatTableItem } from '../mandater'
import { SvgConfig } from '../MandatsamlingSvg/MandatsamlingSvg'
import { createSizeCalc } from '../../../../lib/mandat-svg/SvgHelper'

import style from './MandatsamlingLegend.css'

type Props = {
  items: MandatTableItem[]
  config: SvgConfig
}

export function MandatsamlingLegend(props: Props) {
  const { items, config } = props
  return (
    <div
      class={style.mandatsamlingLegend}
      aria-hidden="true"
      style={{
        '--mandat-size': createSizeCalc(config.radius, '100vw', 2),
        '--mandat-max-size': createSizeCalc(config.radius, '800px', 2)
      }}
    >
      {items
        .filter(item => item.antall !== undefined && item.antall > 0)
        .map(item => {
          return (
            <span class={style.mandatsamlingLegend__item}>
              <span style={{ background: item.farge }} />
              {item.kortNavn}
            </span>
          )
        })}
    </div>
  )
}
